const config = {
  companyName: process.env.REACT_APP_COMPANY_NAME || 'Orivanta Labs Private Limited',
  // Add other environment variables here as needed
};

export default config; 